import React from 'react';
import PropTypes from 'prop-types';
import AppHeader from '../AppHeader';
import WLSHeader from './WLSHeader';

const HEADERS = {
  wls: WLSHeader,        
  default: AppHeader     
};

const BrandHeader = ({ brand, theme, session }) => {
  const HeaderComponent = HEADERS[brand] || HEADERS.default;
  return <HeaderComponent brand={brand} theme={theme} session={session} />;
};

BrandHeader.defaultProps = {
  session: undefined
};

BrandHeader.propTypes = {
  brand: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object.isRequired,
  session: PropTypes.shape({
    token: PropTypes.string
  })
};

export default BrandHeader;